export default "__VITE_ASSET__D6zP6dvw__"